// Deutsches Wörterbuch — Schlüssel spiegeln sq.js.
const de = {
  // Header
  'header.ann.shipping': 'schneller Versand',
  'header.ann.guarantee': '30 Tage Garantie',
  'header.about': 'Über uns',
  'header.contact': 'Kontakt',
  'header.search': 'Suchen',
  'header.searchEmpty': 'Keine Produkte gefunden',
  'header.wishlist': 'Wunschliste',
  'header.cart': 'Warenkorb',
  'header.menu': 'Menü',

  // Footer
  'footer.contact': 'Kontakt',
  'footer.policiesTitle': 'Richtlinien und Nutzungsbedingungen',
  'footer.terms': 'Allgemeine Geschäftsbedingungen',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.legal': 'Rechtliche Hinweise',
  'footer.returns': 'Rückgaberichtlinie',
  'footer.shippingPolicy': 'Versandrichtlinie',
  'footer.newsletterTitle': 'Abonnieren Sie unsere E-Mails',
  'footer.newsletterDesc': 'Erhalten Sie Neuigkeiten und Angebote von Fletaime.',
  'footer.emailPlaceholder': 'E-Mail-Adresse',
  'footer.subscribe': 'Abonnieren',
  'footer.copyright': '© 2026 Fletaime, Alle Rechte vorbehalten.',

  // Kategorien
  'cat.travel': 'Travel Book',
  'cat.wedding': 'Love Book',
  'cat.baby': 'Baby Book',
  'cat.kitchen': 'Küchentagebuch',
  'cat.agenda': 'Planer 2026',
  'cat.kids': 'Kids Book',
  'cat.frame': 'Wandrahmen',
  'cat.all': 'Alle Produkte',

  // Produktkarte
  'card.new': 'neu',
  'card.orderNow': 'Jetzt bestellen',
  'card.addWish': 'Zur Wunschliste hinzufügen',
  'card.removeWish': 'Von der Wunschliste entfernen',

  // Home
  'home.heroSubtitle': 'personalisierte Bücher, die Ihre Momente in etwas Echtes verwandeln',
  'home.orderNow': 'Jetzt bestellen',
  'home.rowPrev': 'Zurück',
  'home.rowNext': 'Weiter',
  'home.seeAllModels': 'Alle Designs ansehen →',
  'home.brandTitle': 'die Marke kennenlernen',
  'home.brandSub': 'die Geschichte hinter Ihren Geschichten',
  'home.story1Title': 'Momente, die bleiben',
  'home.story1Text': 'Fletaime erweckt Ihre liebsten Erinnerungen zum Leben — mit sorgfältig gefertigten Fotobüchern, die Sie für immer in den Händen halten können.',
  'home.story2Title': 'gemacht, um geliebt zu werden',
  'home.story2Text': 'Gemacht, um oft durchgeblättert und sichtbar aufbewahrt zu werden — nicht, um in einer Schublade vergessen zu werden.',
  'home.story3Title': 'Ihre Geschichte, Ihre Art',
  'home.story3Text': 'Mit einfachen Werkzeugen und voller Personalisierung legt Fletaime die Kreativität in Ihre Hände — jede Erinnerung wird zu etwas Persönlichem.',
  'home.story4Title': 'Verbindungen, die uns vereinen',
  'home.story4Text': 'Über das Bewahren von Erinnerungen hinaus feiern wir die Verbindungen, die sie zwischen Menschen, Orten und Momenten schaffen.',
  'home.testimonialsTitle': 'Was unsere Kunden sagen',
  'home.galleryTitle': 'fletaime + Sie',
  'home.gallerySub': 'von Ihnen erstellt, von uns geliebt',
  'home.gallerySocial': 'finden Sie uns in den sozialen Medien',
  'home.helpTitle': 'Brauchen Sie Hilfe?',
  'home.helpDesc': 'Schreiben Sie uns auf WhatsApp oder per E-Mail — unser Team antwortet schnell.',

  // Katalog (/photobooks)
  'catalog.bestsellers': 'Bestseller',
  'catalog.albums': 'Alben',
  'catalog.loading': 'Produkte werden geladen...',
  'catalog.noBestsellers': 'Noch keine Produkte als "Bestseller" markiert.',
  'catalog.options': 'Optionen',
  'catalog.searchPlaceholder': 'Suchen',
  'catalog.selectedCount': 'Ausgewählte Produkte:',
  'catalog.sortDefault': 'Standardsortierung',
  'catalog.sortPriceAsc': 'Preis: aufsteigend',
  'catalog.sortPriceDesc': 'Preis: absteigend',
  'catalog.sortName': 'Name (A-Z)',
  'catalog.noResults': 'Keine Produkte für diesen Filter gefunden.',

  // Warenkorb / Wunschliste
  'shoplist.cartTitle': 'Mein Warenkorb',
  'shoplist.cartEmpty': 'Ihr Warenkorb ist leer.',
  'shoplist.viewProducts': 'Produkte ansehen',
  'shoplist.continueOrder': 'Bestellung fortsetzen',
  'shoplist.remove': 'Entfernen',
  'shoplist.total': 'Gesamt:',
  'shoplist.wishTitle': 'Wunschliste',
  'shoplist.wishEmpty': 'Sie haben noch keine Lieblingsprodukte.',
  'card.view': 'Produkt ansehen',

  // Produktseite
  'product.loading': 'Produkt wird gesucht...',
  'product.features': 'Merkmale:',
  'product.totalPrice': 'Gesamtpreis:',
  'product.inCart': '✓ Im Warenkorb',
  'product.addToCart': 'In den Warenkorb',
  'product.choosePhotos': 'Wählen Sie die Anzahl der Fotos',
  'pageOption.50to75': '50 bis 75 Fotos',
  'pageOption.75to150': '75 bis 150 Fotos',
  'product.kitchenNote': 'Für Ihre Personalisierungsidee schreiben Sie uns im Kommentarfeld des Formulars',
  'product.order': 'Bestellen',
  'product.designOnline': 'Buch online gestalten',
  'product.security': '100% sicher – Ihre Daten sind geschützt.',
  'product.tryFramePhoto': 'Testen Sie Ihr Foto im Rahmen',
  'product.uploadFramePhoto': 'Foto in den Rahmen hochladen',
  'product.frameHint': 'Laden Sie ein Foto hoch, um zu sehen, wie es im Rahmen aussieht',
  'product.uploadPhoto': 'Foto hochladen',
  'product.kidsHint': 'Laden Sie 1 Foto für Ihr Kids Book hoch',
  'product.uploadedPhotos': 'Hochgeladene Fotos ({n})',
  'product.customizeTitle': 'Personalisieren Sie Ihr Buch',
  'product.seeOurProducts': 'Unsere Produkte ansehen',
  'product.seeDetails': 'DETAILS ANSEHEN',
  'product.promoPrice': 'Aktionspreis',
  'product.alert.rawFormat': 'Das Foto "{name}" hat ein nicht unterstütztes RAW/TIFF-Format.\n\nBitte exportieren Sie es als JPG und versuchen Sie es erneut.',
  'product.alert.notPhotos': 'Einige Dateien sind keine Fotos.\n\nUngültige Dateien: {names}\n\nBitte laden Sie nur Fotos hoch.',
  'product.alert.maxReached': 'Sie haben das Maximum von {max} Fotos für das gewählte Paket ({label}) erreicht.\n\nWenn Sie mehr Fotos hochladen möchten, wählen Sie ein größeres Paket.',
  'product.alert.remainingOnly': 'Sie können nur noch {remaining} weitere Fotos hochladen.\n\nGewähltes Paket: {label} (max. {max} Fotos)',
  'product.alert.onlyPhotos': 'Bitte laden Sie nur Fotos hoch.',

  // Fotobuch-Designer
  'designer.defaultTitle': 'Photo Book',
  'designer.openDrawer': 'Panel öffnen',
  'designer.closeDrawer': 'Panel schließen',
  'designer.pageLimits': 'Seitenlimits',
  'designer.uploadMore': 'Laden Sie mehr Fotos hoch ({n}/5 min), um zu beginnen.',
  'designer.uploadedCount': 'Sie haben {count} / {max} Fotos hochgeladen.',
  'designer.maxLine': 'Max: {maxPhotos} Fotos | {maxPages} Seiten',
  'designer.statPages': 'Seiten',
  'designer.statPhotosInPages': 'Fotos in Seiten',
  'designer.statUploaded': 'Hochgeladen',
  'designer.processing': 'Wird verarbeitet...',
  'designer.continueOrder': 'Weiter zur Bestellung',
  'designer.previewBtn': 'Als Buch ansehen',
  'preview.title': 'Buchvorschau',
  'preview.editBtn': 'Weiter bearbeiten',
  'preview.prev': 'Vorherige Seite',
  'preview.next': 'Nächste Seite',
  'preview.pageCounter': 'Seite {current} / {total}',
  'designer.minPhotosWarning': 'Laden Sie mindestens 5 Fotos hoch, um fortzufahren',
  'designer.helpTitle': 'Tipps',
  'designer.customizeCover': 'Cover anpassen',
  'designer.help1': 'Laden Sie Fotos hoch, indem Sie auf "+ Fotos hinzufügen" klicken',
  'designer.help2': 'Klicken Sie auf einen leeren Platz, um direkt ein Foto hochzuladen',
  'designer.help3': 'Wählen Sie verschiedene Layouts für Ihre Seiten',
  'designer.help4': 'Wenn Sie fertig sind, klicken Sie auf "Weiter zur Bestellung"',
  'designer.preparing': 'Wird vorbereitet...',
  'designer.pageWord': 'Seiten',
  'designer.alert.noPhotosInPages': 'Bitte fügen Sie mindestens ein Foto auf einer Seite hinzu, bevor Sie mit der Bestellung fortfahren.',
  'designer.alert.unplaced': '{count} Fotos wurden hochgeladen, aber auf KEINER Seite platziert - sie werden NICHT im gedruckten Buch enthalten sein:\n\n{names}\n\nBitte platzieren Sie diese Fotos auf einer Seite (oder entfernen Sie sie aus der Bibliothek, wenn Sie sie nicht möchten), bevor Sie fortfahren.',
  'designer.alert.genericError': 'Ein Fehler ist aufgetreten: {message}',

  // Cover-Editor
  'cover.zoomIn': 'Vergrößern',
  'cover.zoomOut': 'Verkleinern',
  'cover.rotate': 'Drehen',
  'cover.reset': 'Zurücksetzen',
  'cover.delete': 'Löschen',
  'cover.uploadPhoto': 'Foto hochladen',
  'cover.textAndColors': 'Text & Farben',
  'cover.background': 'Hintergrund',
  'cover.titleColor': 'Titelfarbe',
  'cover.yearColor': 'Jahresfarbe',
  'cover.urlColor': 'URL-Farbe (Rückseite)',
  'cover.font': 'Schriftart',
  'cover.titleSize': 'Titelgröße:',
  'cover.yearSize': 'Jahresgröße:',
  'cover.titleLabel': 'Titel',
  'cover.titlePlaceholder': 'z.B. BARCELONA',
  'cover.yearLabel': 'Jahr',
  'cover.spineTitleLabel': 'Buchrücken-Titel (oben)',
  'cover.spineTitlePlaceholder': 'z.B. Land',
  'cover.spineDateLabel': 'Buchrücken-Datum (unten)',
  'cover.spineDatePlaceholder': 'z.B. 2026',
  'cover.introTitle': 'Gestalte dein Cover nach deinem Geschmack',
  'cover.introText': 'Du kannst Titel, Foto und Farben des Covers ändern. Es gibt jetzt auch einen seitlichen Streifen (Buchrücken) mit editierbarem Text — ändere "Land" und "Datum" nach Belieben.',
  'cover.introClose': 'Verstanden',
  'cover.spineColor': 'Textfarbe des Buchrückens',
  'cover.spineNote': 'Dieser Text wird auch auf dem fertigen Produkt gespeichert, als eigene Buchrücken-Seite.',
  'cover.layoutTitle': 'Cover-Layout',
  'cover.back': 'Rückseite',
  'cover.front': 'Vorderseite',
  'cover.layout1Photo': '1 Foto',
  'cover.layout4Photo': '4 Fotos',
  'cover.layoutFullPage': 'Ganzseitig',
  'cover.tabText': 'Text',
  'cover.tabLayout': 'Layout',
  'cover.tabStickers': 'Sticker',
  'cover.stickersTitle': 'Sticker',
  'cover.stickersLoading': 'Wird geladen...',
  'cover.stickersEmpty': 'Noch keine Sticker in dieser Kategorie.',
  'cover.layoutNoPhoto': 'Kein Foto',
  'cover.previewNote': '33 × 48 cm · Ziehen Sie den Text, um ihn zu verschieben',

  // Seitenlayout-Namen
  'pagesLayout.single': 'Ein Foto (ganze Seite)',
  'pagesLayout.two-horizontal': 'Zwei Fotos, horizontal',
  'pagesLayout.three-top': 'Drei Fotos (1 oben, 2 unten)',
  'pagesLayout.four-grid': 'Vier Fotos (Raster)',
  'pagesLayout.collage': 'Collage (5 Fotos)',

  // Seitenmanager (Designer)
  'pages.pageNumber': 'Seite {n}',
  'pages.pageRangeNumber': 'Seite {a}-{b}',
  'pages.uploadSlot': 'Foto hochladen',
  'pages.myPhotos': 'Meine Fotos',
  'pages.loading': 'Wird geladen...',
  'pages.addPhotos': '+ Fotos hinzufügen',
  'pages.addFromPhone': 'Vom Handy hinzufügen',
  'pages.pairingTitle': 'Fotos vom Handy hinzufügen',
  'pages.pairingSubtitle': 'Scanne den QR-Code oder öffne den Link auf deinem Handy, wähle deine Fotos aus, und sie erscheinen automatisch hier.',
  'pages.copy': 'Kopieren',
  'pages.copied': 'Kopiert ✓',
  'pages.pairingAdded': '✓ {count} Foto(s) vom Handy hinzugefügt',
  'pages.pairingWaiting': 'Warte auf Fotos vom Handy...',
  'pages.close': 'Schließen',
  'pages.maxPhotosShort': 'Max. {max} Fotos',
  'pages.aiGeneratingTitle': 'Wird mit KI generiert',
  'pages.aiWarningStrong': 'Die KI kann Fehler machen',
  'pages.aiWarningRest': ', wir analysieren Ihre Fotos und erstellen die Seiten',
  'pages.bgLabel': 'Hintergrund:',
  'pages.uploadMorePhotos': 'Laden Sie mehr Fotos hoch ({n}/5 min)',
  'pages.photoStats': '{count} / {max} Fotos - max. {maxPages} Seiten',
  'pages.font': 'Schriftart',
  'pages.fontSize': 'Größe',
  'pages.style': 'Stil',
  'pages.alignment': 'Ausrichtung',
  'pages.color': 'Farbe',
  'pages.applyAllPages': 'Auf alle Seiten anwenden',
  'pages.deleteText': '🗑 Text löschen',
  'pages.addPageTitle': 'Neue Seite hinzufügen',
  'pages.addPageLimitTitle': 'Limit erreicht ({max} Seiten)',
  'pages.addPageBtn': '+ Seite hinzufügen ({count}/{max})',
  'pages.changeLayout': '🔲 Layout ändern',
  'pages.addText': 'T Text hinzufügen',
  'pages.deletePage': '🗑 Seite löschen',
  'pages.coverThumb': 'Cover',
  'pages.chooseLayout': 'Layout wählen',
  'pages.alert.slotLimit': 'Sie haben die maximale Anzahl an Fotos für dieses Produkt erreicht.',
  'pages.alert.maxForProduct': 'Sie haben das Maximum von {max} Fotos für dieses Produkt erreicht.\n\nEntfernen Sie einige Fotos aus den Seiten/der Bibliothek, um neue hinzuzufügen.',
  'pages.alert.limitSkipped': 'Sie haben das Limit von {max} Fotos erreicht - Sie können nur noch {remaining} weitere hinzufügen.\n\nDiese Fotos wurden NICHT hinzugefügt:\n{names}',
  'pages.alert.loadError': 'Beim Laden der Fotos ist ein Fehler aufgetreten.',
  'pages.alert.maxPhotosLimit': 'Sie haben das Maximum von {max} Fotos für dieses Produkt erreicht.',
  'pages.alert.remainingOnly': 'Sie können nur noch {remaining} weitere Fotos hochladen. {added} von {total} ausgewählten Fotos wurden hochgeladen.',
  'pages.alert.minAI': 'Bitte laden Sie mindestens 3 Fotos hoch, um mit KI zu generieren.',
  'pages.alert.aiError': 'Bei der Generierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'pages.alert.maxPages': 'Sie haben die maximale Anzahl an Seiten erreicht ({max}).',
  'pages.deletePhotoTitle': 'Foto löschen',
  'pages.moveSlot': 'Platz verschieben',
  'pages.rotate90': 'Nach rechts drehen',
  'pages.rotateLeft90': 'Nach links drehen',
  'pages.rotateFree': 'Ziehen, um frei zu drehen',
  'pages.fitPhoto': 'Zuschnitt zurücksetzen',
  'pages.aiHintBefore': 'Laden Sie Ihre Fotos hier hoch und die',
  'pages.aiHintAfter': 'erstellt automatisch Ihr Album.',
  'pages.aiGenerateBtn': 'Layout mit KI generieren',

  // Bestellseite (OrderForm)
  'order.loadingOrder': 'Wird geladen...',
  'order.noData': 'Keine Bestelldaten',
  'order.backToStart': 'Zurück zum Anfang',
  'order.beforeUnloadWarning': 'Der Fotoupload läuft gerade. Sind Sie sicher, dass Sie die Seite verlassen möchten?',
  'order.validation.firstName': 'Vorname ist erforderlich',
  'order.validation.lastName': 'Nachname ist erforderlich',
  'order.validation.country': 'Land ist erforderlich',
  'order.validation.city': 'Stadt ist erforderlich',
  'order.validation.address': 'Adresse ist erforderlich',
  'order.validation.phone': 'Telefonnummer ist erforderlich',
  'order.validation.phoneInvalid': 'Telefonnummer ist ungültig',
  'order.promo.applied': 'Code angewendet! -{pct}% Rabatt',
  'order.promo.invalid': 'Aktionscode ist ungültig',
  'order.alert.uploadFailedSlots': '{count} Foto(s) konnten nicht hochgeladen werden und würden im gedruckten Buch fehlen. Bitte aktualisieren Sie die Seite, überprüfen Sie die Fotobuchseiten und platzieren Sie die Fotos erneut, bevor Sie fortfahren.',
  'order.error.initFailed': 'Fehler beim Starten der Bestellung (Status: {status}). {text}',
  'order.error.initFailedGeneric': 'Fehler beim Starten der Bestellung!',
  'order.error.noPhotosUploaded': 'Kein Foto wurde erfolgreich hochgeladen. Bitte versuchen Sie es erneut mit einer stabileren Internetverbindung (oder öffnen Sie diese Seite in Safari/Chrome statt in Instagram/Facebook).',
  'order.alert.saveFailed': 'Fehler beim Speichern der Bestellung!',
  'order.error.checkoutFailed': 'Fehler beim Erstellen der Online-Zahlung',
  'order.error.submitFailed': 'Fehler beim Absenden der Bestellung!',
  'order.error.timeout': 'Der Fotoupload dauert lange.\n\nDas könnte daran liegen:\n- Ihre Internetverbindung ist langsam\n- Der Server ist ausgelastet\n\nBitte versuchen Sie es erneut mit einer stabileren Internetverbindung.',
  'order.error.connectionDropped': 'Die Verbindung zum Server wurde beim Absenden Ihrer Bestellung unterbrochen ({message}).\n\nDies passiert normalerweise durch:\n- Die Internetverbindung wurde kurz unterbrochen (WLAN/Mobilfunknetz)\n- Das Telefon wurde während des Uploads in den Hintergrund versetzt oder der Bildschirm gesperrt\n\nBitte versuchen Sie es erneut mit einer stabileren Internetverbindung und schließen Sie die Seite nicht, bis der Vorgang abgeschlossen ist.',
  'order.uploadTitle': 'Bitte bleiben Sie hier bei uns',
  'order.uploadWarning': 'Das Hochladen aller Fotos der Bestellung dauert 3 bis 5 Minuten.',
  'order.manualSuccessTitle': 'Vielen Dank für Ihre Bestellung!',
  'order.manualSuccessAllOk': 'Ihre Fotos wurden erfolgreich hochgeladen.',
  'order.manualSuccessPartial': '{done} von {total} Fotos wurden erfolgreich hochgeladen.',
  'order.photoLinkReady': '📸 Ihr Fotolink ist bereit. Sie können ihn ansehen oder zum Speichern kopieren.',
  'order.someFailedManual': '⚠️ {count} Foto(s) konnten nicht hochgeladen werden: {names}. Diese Dateien kamen leer von Ihrem Telefon an - dies passiert oft bei iCloud-Fotos, die nicht vollständig heruntergeladen wurden, oder wenn Sie diese Seite in Instagram/Facebook statt in Safari/Chrome öffnen. Bitte versuchen Sie, diese Fotos separat hinzuzufügen, oder kontaktieren Sie uns für Hilfe.',
  'order.viewPhotos': '📸 Fotos ansehen',
  'order.linkCopied': '✅ Link kopiert!',
  'order.copyLink': '🔗 Link kopieren',
  'order.backHome': 'Zur Startseite',
  'order.inAppWarningBefore': '⚠️ Sie öffnen diese Seite in {browser}. Um Probleme beim Hochladen von Fotos zu vermeiden, öffnen Sie sie in Safari oder Chrome: tippen Sie oben rechts auf ⋮ oder ••• und wählen Sie',
  'order.inAppOpenBrowser': '"Im Browser öffnen"',
  'order.inAppWarningAfter': '("Open in Browser" / "Open in Safari").',
  'order.summaryTitle': 'Bestellübersicht',
  'order.discountApplied': '-{pct}% Rabatt angewendet',
  'order.shippingLine': '{price}€ + {shipping}€ Versand',
  'order.pagesCount': 'Anzahl der Seiten:',
  'order.photosInPages': 'Fotos in Seiten:',
  'order.photosCountUnit': '{n} Fotos',
  'order.photosUploaded': 'Hochgeladene Fotos:',
  'order.photoBookDesigned': '📖 Gestaltetes Fotobuch',
  'order.photoBookDesignedDesc': 'Sie haben {pages} Seiten mit {photos} Fotos gestaltet.',
  'order.pdfAutoNote': 'Die PDF wird automatisch generiert, wenn Sie die Bestellung absenden.',
  'order.shippingNote': '📦 Versand: Kosovo +2€ | Albanien +5€ | Nordmazedonien +5€',
  'order.yourPhotos': 'Ihre Fotos:',
  'order.yourDataTitle': 'Ihre Daten',
  'order.firstName': 'Vorname *',
  'order.firstNamePlaceholder': 'Geben Sie Ihren Vornamen ein',
  'order.lastName': 'Nachname *',
  'order.lastNamePlaceholder': 'Geben Sie Ihren Nachnamen ein',
  'order.country': 'Land *',
  'order.countrySelect': '-- Land auswählen --',
  'order.countryKosovo': '🇽🇰 Kosovo (+2€ Versand)',
  'order.countryAlbania': '🇦🇱 Albanien (+5€ Versand)',
  'order.countryMacedonia': '🇲🇰 Nordmazedonien (+5€ Versand)',
  'order.city': 'Stadt *',
  'order.cityPlaceholder': 'Geben Sie Ihre Stadt ein',
  'order.address': 'Adresse *',
  'order.addressPlaceholder': 'Geben Sie Ihre vollständige Adresse ein',
  'order.phone': 'Telefonnummer *',
  'order.comments': 'Kommentar / Beschreibung (Optional)',
  'order.commentsPlaceholder': 'Schreiben Sie einen Kommentar oder eine Beschreibung zu Ihrer Bestellung (optional)',
  'order.promoLabel': 'Aktionscode (Optional)',
  'order.promoPlaceholder': 'Geben Sie den Aktionscode ein',
  'order.apply': 'Anwenden',
  'order.paymentMethod': 'Zahlungsmethode',
  'order.payCash': 'Barzahlung bei Lieferung',
  'order.payCashSub': 'Zahlen Sie, wenn Ihre Bestellung ankommt',
  'order.payOnline': 'Online bezahlen',
  'order.payOnlineSub': 'Schnelle und sichere Zahlung',
  'order.payOnlineDiscountBadge': '-{pct}%',
  'order.paymentSecurityNote': 'Online-Zahlungen werden sicher über Stripe abgewickelt.',
  'order.processingPhotoBook': '⏳ Fotobuch wird verarbeitet... Bitte warten',
  'order.processingPhotos': '⏳ Fotos werden hochgeladen... Bitte warten',
  'order.sendManual': '📤 Bestellung absenden',
  'order.continueToPay': 'Weiter zur Zahlung',
  'order.sendWhatsApp': 'Bestellung per WhatsApp senden',
  'order.generatingPdf': '⏳ PDF mit {pages} Seiten wird generiert... Seite nicht schließen!',
  'order.uploadingPhotosCount': '⏳ {n} Fotos werden hochgeladen... Seite nicht schließen!',
  'order.noteManual': '* Durch Klicken auf die Schaltfläche werden Ihre Fotos hochgeladen und Sie erhalten den Link, um sie anzusehen',
  'order.noteCard': '* Durch Klicken auf die Schaltfläche gelangen Sie zur sicheren Zahlungsseite',
  'order.noteWhatsApp': '* Durch Klicken auf die Schaltfläche wird Ihre Bestellung per WhatsApp gesendet',
  'order.successTitle': 'Bestellung erfolgreich gesendet!',
  'order.successOpened': 'WhatsApp sollte automatisch geöffnet worden sein.',
  'order.pdfSentLabel': 'Fotobuch-PDF:',
  'order.pdfSentDesc': 'Die PDF mit {pages} Seiten wurde generiert und mit der Bestellung gesendet.',
  'order.remindSendLabel': 'Nicht vergessen:',
  'order.remindSendDesc': 'Senden Sie die {n} ausgewählten Fotos im WhatsApp-Chat!',
  'order.someFailedBackup': '⚠️ {count} Foto(s) wurden nicht als Sicherungskopie auf unserem Server gespeichert: {names}. Dies passiert oft bei iCloud-Fotos, die nicht vollständig heruntergeladen wurden, oder wenn Sie diese Seite in Instagram/Facebook öffnen. Stellen Sie sicher, dass Sie diese Fotos selbst im WhatsApp-Chat senden.',
  'order.ifNotOpened': 'Falls WhatsApp nicht geöffnet wurde, klicken Sie auf die Schaltfläche unten:',
  'order.openWhatsAppManually': '📱 WhatsApp manuell öffnen',

  // WhatsApp-Bestellnachricht — wird in der Sprache des Kunden erstellt
  'wa.title': '🎉 *NEUE BESTELLUNG* 🎉',
  'wa.product': '📦 *Produkt:*',
  'wa.priceBefore': '💰 *Produktpreis (vor Rabatt):*',
  'wa.promoCode': '🏷️ *Aktionscode:*',
  'wa.priceAfterDiscount': '💸 *Preis nach Rabatt:*',
  'wa.price': '💰 *Produktpreis:*',
  'wa.shipping': '🚚 *Versand ({country}):*',
  'wa.totalPrice': '✅ *Gesamtpreis:*',
  'wa.bookDetails': '📖 *Buchdetails:*',
  'wa.bookWith': '• Buch mit:',
  'wa.pagesWord': 'Seiten',
  'wa.photosInPage': '• Anzahl der Fotos in den Seiten:',
  'wa.productDetails': '📦 *Produktdetails:*',
  'wa.photosCount': '• Anzahl der Fotos:',
  'wa.customerData': '👤 *Kundendaten:*',
  'wa.name': '• Name:',
  'wa.country': '• Land:',
  'wa.city': '• Stadt:',
  'wa.address': '• Adresse:',
  'wa.phone': '• Telefon:',
  'wa.comment': '• Kommentar:',
  'wa.bookPagesZip': '📦 *Buchseiten (ZIP):*',
  'wa.downloadPages': 'Buchseiten hier herunterladen:',
  'wa.customerPhotos': '📸 *Kundenfotos:*',
  'wa.seePhotos': 'Fotos hier ansehen:',
  'wa.waitingConfirm': '⏳ Warte auf Bestellbestätigung.',
  'wa.orderDate': '*Bestelldatum:*',

  // OrderSuccess (Stripe)
  'success.checking': 'Zahlung wird bestätigt...',
  'success.confirmed': 'Zahlung erfolgreich!',
  'success.thanks': 'Vielen Dank für Ihre Bestellung!',
  'success.confirmedDesc': 'Bestellung #{id} wurde bezahlt und registriert. Wir kontaktieren Sie bald mit den Versanddetails.',
  'success.pendingDesc': 'Bestellung #{id} wurde gesendet. Sobald die Zahlung vollständig bestätigt ist, werden Sie benachrichtigt.',
  'success.sendConfirmBtn': '📱 Bestätigung per WhatsApp senden',
  'success.backHome': 'Zur Startseite',
  'wa.success.title': '✅ *Zahlung erfolgreich*',
  'wa.success.paidLine': 'Bestellung #{id} wurde online bezahlt.',
  'wa.success.name': 'Name:',
  'wa.success.product': 'Produkt:',
  'wa.success.price': 'Preis:',
  'wa.success.wantConfirm': 'Ich möchte eine Bestätigung der Bestellung.',

  // OrderCancel (Stripe)
  'cancel.orderNotFound': 'Bestellung nicht gefunden',
  'cancel.genericError': 'Fehler beim Erstellen der Zahlung',
  'cancel.retryError': 'Fehler beim erneuten Versuch der Zahlung. Bitte versuchen Sie es erneut.',
  'cancel.title': 'Zahlung abgebrochen',
  'cancel.desc': 'Bestellung #{id} wurde gespeichert, aber die Zahlung wurde nicht abgeschlossen. Sie können es erneut versuchen oder uns auf WhatsApp kontaktieren, um Barzahlung zu vereinbaren.',
  'cancel.retrying': '⏳ Zahlung wird geöffnet...',
  'cancel.retryBtn': '💳 Erneut versuchen',
  'cancel.contactBtn': '📱 Auf WhatsApp kontaktieren',
  'wa.cancel.message': 'Hallo, ich habe eine Bestellung (#{id}), aber die Online-Zahlung hat nicht funktioniert. Können wir das mit Barzahlung regeln?',

  // OrderImages
  'images.loading': 'Fotos werden geladen...',
  'images.notFoundTitle': '❌ Bestellung nicht gefunden!',
  'images.notFoundDesc': 'Der Link ist möglicherweise alt oder ungültig.',
  'images.pageTitle': '📸 Bestellfotos',
  'images.back': '← Zurück',
  'images.cardTitle': 'Bestellfotos',
  'images.orderId': 'Bestell-ID:',
  'images.photoCount': 'Anzahl der Fotos:',
  'images.date': 'Datum:',
  'images.downloadAll': '⬇️ Alle Fotos herunterladen ({n})',
  'images.downloadHint': 'Oder klicken Sie auf ein Foto, um es einzeln herunterzuladen',
  'images.download': '⬇️ Herunterladen',
  'images.photoWord': 'Foto {n}',
  'images.noImages': 'Keine Fotos für diese Bestellung hochgeladen.',
  'images.homeBtn': '🏠 Zur Startseite',

  // Richtlinienseiten
  'policy.backLink': '← Zurück zur Startseite',

  'policy.privacy.title': 'Datenschutzerklärung',
  'policy.privacy.subtitle': 'Fletaime - Schutz Ihrer Daten',
  'policy.privacy.intro': 'Fletaime respektiert und schützt die Privatsphäre jedes Nutzers unserer Plattform. Diese Richtlinie erklärt, wie wir die Daten und Materialien sammeln, verwenden und schützen, die Nutzer auf unsere Plattform hochladen.',
  'policy.privacy.s1Title': 'Datenerhebung',
  'policy.privacy.s1Text': 'Bei der Nutzung der Fletaime-Plattform können Nutzer Fotos hochladen und grundlegende Daten wie Vorname, Nachname und die für die Bestellabwicklung erforderlichen Informationen angeben. Diese Daten werden ausschließlich zur Bearbeitung und Abwicklung der Kundenbestellung verwendet.',
  'policy.privacy.s2Title': 'Sicherheit der Fotos',
  'policy.privacy.s2Text': 'Wir garantieren, dass alle von Nutzern hochgeladenen Fotos mit einem hohen Maß an Sicherheit und Datenschutz behandelt werden. Die Fotos werden ausschließlich zur Herstellung des bestellten Albums oder Produkts verwendet und für keinen anderen Zweck genutzt.',
  'policy.privacy.s2Guarantee': 'Fletaime garantiert, dass:',
  'policy.privacy.s2Li1': 'Fotos nicht an Dritte weitergegeben werden.',
  'policy.privacy.s2Li2': 'Fotos ohne Zustimmung des Kunden nicht für Marketing oder Werbung verwendet werden.',
  'policy.privacy.s2Li3': 'Sie während der Bestellbearbeitung auf sicheren Systemen gespeichert werden.',
  'policy.privacy.s3Title': 'Löschung der Fotos',
  'policy.privacy.s3Text': 'Nach Abschluss des Design-, Produktions- und Lieferprozesses der Kundenbestellung werden die hochgeladenen Fotos innerhalb einer angemessenen technischen Frist aus unseren Systemen gelöscht. Dies dient der vollständigen Gewährleistung des Datenschutzes und der Sicherheit der Kundendaten.',
  'policy.privacy.s4Title': 'Datenschutz',
  'policy.privacy.s4Text': 'Fletaime handelt in Übereinstimmung mit den geltenden Rechtsvorschriften der Republik Kosovo zum Schutz personenbezogener Daten und ergreift technische und organisatorische Maßnahmen, um die Nutzerinformationen vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen.',

  'policy.return.title': 'Rückgaberichtlinie',
  'policy.return.subtitle': 'Fletaime - Garantie und Qualität',
  'policy.return.intro': 'Fletaime verpflichtet sich, hochwertige Produkte anzubieten, die nach den Anforderungen der Kunden gefertigt werden. Jede Bestellung durchläuft mehrere Kontrollphasen, bevor sie an den Kunden versandt wird.',
  'policy.return.s1Title': 'Qualitätskontrolle',
  'policy.return.s1Text': 'Vor dem Versand wird jedes bestellte Album oder Produkt von unserem Team im Detail geprüft, um sicherzustellen, dass:',
  'policy.return.s1Li1': 'Das Design gemäß den Anforderungen des Kunden erstellt wurde',
  'policy.return.s1Li2': 'Die Materialien und der Druck in einwandfreiem Zustand sind',
  'policy.return.s1Li3': 'Das Produkt gemäß unseren Qualitätsstandards fertiggestellt ist',
  'policy.return.s1Note': 'Erst nach dieser Prüfung wird die Bestellung zum Versand freigegeben.',
  'policy.return.s2Title': 'Schäden während des Transports',
  'policy.return.s2Text': 'In manchen Fällen kann das Produkt während des Transports durch das Zustellunternehmen beschädigt werden. Wenn der Kunde die Bestellung erhält und feststellt, dass sie beschädigt angekommen ist, bietet Fletaime einen kostenlosen Produktersatz an.',
  'policy.return.s3Title': 'Design- oder Produktionsfehler',
  'policy.return.s3Text': 'Der Kunde hat Anspruch auf Ersatz der Bestellung in folgenden Fällen:',
  'policy.return.s3Li1': 'Das Design wurde nicht gemäß den Anforderungen des Kunden erstellt',
  'policy.return.s3Li2': 'Das Design-Team hat vergessen, vom Kunden angeforderte Elemente einzufügen',
  'policy.return.s3Li3': 'Es liegen sichtbare Fehler aus dem Produktionsprozess vor',
  'policy.return.s3Li4': 'Das Endprodukt stimmt nicht mit der bestätigten Bestellung überein',
  'policy.return.s3Note': 'In diesen Fällen übernimmt Fletaime die Verantwortung für die Behebung oder den Ersatz des Produkts.',
  'policy.return.s4Title': 'Fälle, in denen keine Rückgabe akzeptiert wird',
  'policy.return.s4Text': 'Da die Produkte für jeden Kunden individuell angefertigt werden, wird eine Rückgabe in folgenden Fällen nicht akzeptiert:',
  'policy.return.s4Li1': 'Der Kunde ändert seine Meinung, nachdem die Bestellung produziert wurde',
  'policy.return.s4Li2': 'Die Bestellung wurde genau nach der vom Kunden bestätigten Anfrage ausgeführt',
  'policy.return.s4Li3': 'Es liegen keine physischen Schäden oder Fehler seitens des Design- oder Produktionsteams vor',

  // Mobile upload (QR pairing) page
  'mobileUpload.title': 'Fotos vom Handy hinzufügen',
  'mobileUpload.subtitle': 'Wähle deine Fotos aus und sie erscheinen automatisch auf deinem Computer.',
  'mobileUpload.addPhotos': 'Fotos hinzufügen',
  'mobileUpload.addMore': 'Mehr hinzufügen',
  'mobileUpload.uploading': 'Wird hochgeladen {done}/{total}...',
  'mobileUpload.done': '{count} Foto(s) erfolgreich hochgeladen!',
  'mobileUpload.doneHint': 'Gehe zurück zu deinem Computer - die Fotos wurden bereits hinzugefügt.',
  'mobileUpload.error': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  // Faqja Rreth nesh
  'about.hero.title': 'Jede Erinnerung verdient es, für immer bewahrt zu werden.',
  'about.hero.lead': 'Fletaime entstand aus einer einfachen Idee mit einer besonderen Bedeutung: unseren Erinnerungen einen Ort zu geben, an dem sie aufbewahrt, berührt und wieder erlebt werden können – egal, wie viel Zeit vergeht.',
  'about.story.eyebrow': 'Unsere Geschichte',
  'about.story.title': 'Eine Idee aus dem Jahr 2021, Wirklichkeit geworden im Jahr 2025.',
  'about.story.p1': 'Die Geschichte von Fletaime begann 2021 mit dem Wunsch, etwas Besonderes zu schaffen, das Menschen hilft, die wichtigsten Momente ihres Lebens zu bewahren.',
  'about.story.p2': 'Doch uns reichte es nicht, einfach ein Fotoalbum zu machen. Wir wollten ein Produkt entwickeln, das die Erwartungen unserer Kunden erfüllt – mit Liebe zu jedem Detail, von der ersten Idee bis zum fertigen Erlebnis.',
  'about.story.p3': 'Deshalb widmeten wir uns in den folgenden Jahren der Entwicklung der Idee sowie dem Testen und Verbessern des Konzepts, mit dem Ziel, ein Produkt zu schaffen, das uns würdig repräsentiert.',
  'about.story.p4': 'Im Jahr 2025 nahm die Idee mit der Veröffentlichung der ersten Version unseres Albums konkrete Gestalt an. Das war erst der Anfang der Reise von Fletaime und unserer Mission, Fotos in bleibende Erinnerungen zu verwandeln.',
  'about.story.p5': 'Heute arbeiten wir weiter daran, jedes Album zu mehr als einer Fotosammlung zu machen: zu einer persönlichen Geschichte, die es verdient, für immer bewahrt zu werden.',
  'about.tl.2021.title': 'Die Idee',
  'about.tl.2021.text': 'Der Wunsch entsteht, die wichtigsten Momente zu bewahren.',
  'about.tl.dev.title': 'Entwicklung',
  'about.tl.dev.text': 'Jahre voller Hingabe: Testen und Verbessern des Konzepts.',
  'about.tl.2025.title': 'Erstes Album',
  'about.tl.2025.text': 'Die Idee nimmt mit der ersten Version Gestalt an.',
  'about.tl.today.title': 'Heute',
  'about.tl.today.text': 'Jedes Album, eine persönliche Geschichte zum Bewahren.',
  'about.mission.eyebrow': 'Unsere Mission',
  'about.mission.title': 'Die kostbarsten Erinnerungen in einer besonderen, bleibenden Form.',
  'about.mission.p1': 'Unsere Mission ist es, Menschen dabei zu helfen, die kostbarsten Erinnerungen ihres Lebens in einer besonderen, persönlichen und langlebigen Form zu bewahren.',
  'about.mission.p2': 'Wir möchten, dass jeder Kunde, der sich für Fletaime entscheidet, einen einfachen und angenehmen Prozess erlebt – von der Gestaltung des Albums bis zu dem Moment, in dem er es in den Händen hält. Erfolg messen wir nicht nur an einem fertigen Produkt, sondern an der Zufriedenheit der Kunden und den Emotionen, die sie beim Wiedersehen ihrer Erinnerungen spüren.',
  'about.mission.p3': 'Jedes Album, das wir gestalten, steht für eine einzigartige Geschichte. Deshalb stehen Qualität, Liebe zum Detail und Kundenzufriedenheit immer im Mittelpunkt unserer Arbeit.',
  'about.mission.quote': 'Wir bewahren nicht nur Fotos. Wir helfen, die Geschichten zu bewahren, die zählen.',
  'about.val.quality': 'Qualität',
  'about.val.detail': 'Liebe zum Detail',
  'about.val.satisfaction': 'Kundenzufriedenheit',
  'about.vision.eyebrow': 'Unsere Vision',
  'about.vision.title': 'Erinnerungen kennen keine Grenzen.',
  'about.vision.p1': 'Unsere Vision ist es, dass Fletaime überall auf der Welt die erste Wahl wird, wenn Menschen ihre Erinnerungen in besondere Alben verwandeln möchten.',
  'about.vision.p2': 'Wir glauben, dass Erinnerungen keine Grenzen kennen und dass jeder Mensch – unabhängig davon, wo er lebt – die Möglichkeit verdient, die wichtigsten Momente seines Lebens in einer Form zu bewahren, die er für immer bei sich tragen kann.',
  'about.vision.p3': 'Deshalb ist es unser Ziel, die Leistungen von Fletaime auf möglichst viele Länder auszuweiten und Kunden aus verschiedenen Ländern die Möglichkeit zu bieten, ihre Alben zu gestalten – mit derselben Hingabe an Qualität und Kundenerlebnis.',
  'about.vision.ambition': 'Unser Ziel ist klar: von einer Idee aus dem Jahr 2021 hin zu einer Marke, die die Erinnerungen von Menschen auf der ganzen Welt zusammenbringt.',
  'about.closing.title': 'Fletaime – Ihre Erinnerungen, Ihre Geschichte.',
  'about.closing.cta': 'Dein Album gestalten',

  // Faqja e kontaktit
  'contact.eyebrow': 'Kontakt',
  'contact.title': 'Schreiben Sie uns, wir sind für Sie da.',
  'contact.lead': 'Haben Sie eine Frage, eine Beschwerde oder eine Idee für uns? Kontaktieren Sie uns, wir antworten so schnell wie möglich.',
  'contact.whatsapp': 'WhatsApp',
  'contact.instagram': 'Instagram',
  'contact.email': 'E-Mail',
  'contact.whatsappHint': 'Schreiben Sie uns direkt',
  'contact.instagramHint': 'Folgen Sie uns und senden Sie eine Nachricht',
  'contact.emailHint': 'Wir antworten so schnell wie möglich',
  'contact.form.title': 'Nachricht senden',
  'contact.form.type': 'Was möchten Sie senden?',
  'contact.form.type.request': 'Anfrage',
  'contact.form.type.complaint': 'Beschwerde',
  'contact.form.type.suggestion': 'Vorschlag',
  'contact.form.name': 'Vor- und Nachname',
  'contact.form.email': 'E-Mail-Adresse',
  'contact.form.phone': 'Telefonnummer (optional)',
  'contact.form.message': 'Ihre Nachricht',
  'contact.form.send': 'Nachricht senden',
  'contact.form.sending': 'Wird gesendet...',
  'contact.form.success': 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns in Kürze.',
  'contact.form.error': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.',
  'contact.form.tooMany': 'Sie haben zu viele Nachrichten gesendet. Bitte versuchen Sie es gleich noch einmal.',
};

export default de;
